
const initialState = {
  isPanoramaLocked: false
}
const SubscriptionReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'IS_PANORAMA_LOCKED': {
      return { ...state, isPanoramaLocked: action.isPanoramaLocked }
    }
    default:
      return state
  }
}

SubscriptionReducer.initialState = initialState
export default SubscriptionReducer
